import React from 'react'

import __uniqueId from 'lodash/uniqueId'

import { FormControl } from '../FormElements/FormControl'
import { FormHelperText } from '../FormElements/FormHelperText'
import { Input } from './Input'
import { InputLabel } from './InputLabel'
import type { TextFieldProps } from './types'

export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (
    { className, label, id, isLabelHighlighted = false, error = false, helperText, required = false, ...inputProps },
    ref
  ) => {
    const inputId = id || __uniqueId('text-field-')
    const helperTextId = `${inputId}-helper-text`

    return (
      <FormControl className={className} error={error}>
        {label && (
          <InputLabel htmlFor={inputId} required={required} error={Boolean(error)} highlighted={isLabelHighlighted}>
            {label}
          </InputLabel>
        )}
        <Input
          aria-describedby={helperText ? helperTextId : undefined}
          aria-invalid={Boolean(error)}
          error={Boolean(error)}
          id={inputId}
          ref={ref}
          required={required}
          {...inputProps}
        />
        {helperText && (
          <FormHelperText id={helperTextId} aria-live="polite">
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
)

TextField.displayName = 'TextField'
